import { Injectable } from "@angular/core";
import { API_METHODS, API_URL } from "common/constants/sm-constants";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { environment } from "src/environments/environment";
import { MentorModel } from "common/models/page-models/mentor/mentor-data-model";
import { FormDataService } from "../../base-data-services/form-data.service";


@Injectable({
    providedIn: 'root'
})
export class MentorFormDataService extends FormDataService<MentorModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.addMentorMaster, http, ss);
    }

    override getEditUrlAndMethod() {
        const edit = {
            url: environment.apiUrl + API_URL.getMentorMasterDataById,
            method: API_METHODS.post
        }
        return edit;
    }

    override getUpdatePayload(data) {
        let payload;
        payload = {
            id: data.id,
            
        }
        return payload;
    }

    createInstance(): MentorModel {
        return new MentorModel();
    }

    override modifyAPIResponse(response: any) {
        return response['details'][0];
    }

    override getUpdateUrl() {
        return API_URL.addMentorMaster;
    }

    override modifyPostModel(formModel: any, dataModel: any) {
        formModel['id'] = dataModel.id;
        return formModel;
    }

}